import React, { useState } from "react";
import {Modal, ModalHeading} from '@sainsburys-tech/luna-modal'
import {
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  FilledButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import "./ldmscandownload.scss";
import { endpoints } from "../../ApiEndPoints/apiEndPoints";
import { request } from "../../Axios/axios-util";
import { saveAs } from "file-saver";
import LoadingIndicator from "../Loading/index";
import CustomToast from "../SharedComponents/CustomToast";
import { errorToast } from "../../Service-Utils/toastMessage";

const LdmScanDownload: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const downloadApp = async () => {
    setShowModal(false);
    setDownloading(true);
    try {
      const res = await request({
        url: endpoints.downloadLDMApp(),
        method: 'GET',
        responseType: 'blob'
      });
      saveAs(res.data, "LDM_Scan_Download.zip");
    } catch (error: any) {
      errorToast(error?.message ?? "Internal server error! Please try again later.");
    }
    setDownloading(false);
  }
  return (
    <div className="ldm-scan-container">
      <CustomToast />
      <div className="content">
        <h1>LDM Scan App Installation</h1>
        <div className="instructions-card">
          <h2>How to Install the App</h2>
          <ol>
            <li>Download and install the LDM Certificate from the Software Centre before continuing.</li>
            <li>Click the button below to download the LDM Scan app.</li>
            <li>Once downloaded, open the file and locate the <code>.MSIXBUNDLE</code> inside.</li>
            <li>Double click the <code>.MSIXBUNDLE</code> file to begin installation.</li>
          </ol>
          <FilledButton 
            className="download-btn"
            onClick={()=>setShowModal(true)}
          >
            Download LDM Scan App
          </FilledButton>
          {downloading && <LoadingIndicator />}
        </div>
        <Modal
          classNanme="familyGroupModal"
          handleClose={() => setShowModal(false)}
          open={showModal}
          headingId="dialog-modal"
        >
          <ModalHeading element="h5" style={{ color: "#e55000" }}>
            Important: LDM Certificate Required
          </ModalHeading>
          
        <div className="modal-body">
          <ul>
            <li>
              Before installing the LDM Scan app, please ensure you have installed the
              <b>LDM Certificate</b>
              from the Software Centre.
            </li>            
            <br />
            <li>
              <b>To install:</b> 
              After download, open the file and locate the 
              <b>MSIXBUNDLE</b> 
              file inside. Double-click the MSIXBUNDLE file to start the installation.
            </li>
          </ul>
        </div>
        <ButtonGroupWrapper actionbar>
            <ButtonGroupPrimary>
              <OutlinedButton
                className="ln-u-margin-right"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </OutlinedButton>
              <FilledButton onClick={() => downloadApp()}>Continue</FilledButton>
            </ButtonGroupPrimary>
          </ButtonGroupWrapper>
      </Modal>
      </div>
    </div>
  );
};

export default LdmScanDownload;